module.exports = __webpack_public_path__ + "img/2e769dabd8a13209f7c0e2d7a033a927.png";